/* eslint-disable */
import { CookieConsent } from "../components/cookie-consent";

export class BlazorInterop
{
	constructor(public readonly cookieConsent: CookieConsent)
	{
	}
}